import { service } from '../../service';
import { icons } from '../../service/icons';

const state = {
  live: {},
};

const mutations = {
  FETCH_LIVE(state, live) {
    state.live = live;
  },
};

const getters = {
  getLive(state) {
    return state.live;
  },
};

const actions = {
  async fetchLive({ commit }, duration) {
    const { data } = await service.getCurrentLive(duration);
    if (data.message === 'no_live_exist_now') commit('FETCH_LIVE', null);
    else commit('FETCH_LIVE', data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/lives.js